import { HTTPService } from "../util/httpManager.js";
import { Helper } from "../util/helper.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import React from "react";
enum MoveDirection {
    Left,
    Right,
    Reoder
}

interface ListBoxSelectState {
    AllValues: any;
    LeftValues: any;
    RightValues: any;
}

export class ListBox extends React.Component<ListBoxSelectProps, ListBoxSelectState>{
    private listBoxRef: any;
    private listBoxContentRef: any;
    private listBox: kendo.ui.ListBox;
    private listBoxContent: kendo.ui.ListBox;
    private disabled = true;
    private id = null;
    private idContent = null;
    public moveDirectionListBox: MoveDirection;
    public moveDirectionListBoxContent: MoveDirection;

    constructor(props) {
        super(props)
        this.id = kendo.guid();
        this.idContent = kendo.guid();
        this.state = {
            AllValues: [],
            LeftValues: [],
            RightValues: []
        }
    }

    componentWillUnmount() {
        this.listBoxContent.destroy();
        this.listBox.destroy();
    }

    getItems = () => {
        return {
            left: this.listBox.dataSource.data(),
            right: this.listBoxContent.dataSource.data()
        };
    }

    componentDidMount() {
        this.createListBoxes();
        this.loadData();
    }

    private createListBoxes = () => {
        this.disabled = this.props.disabled;
        //die linke Liste
        this.listBox = $(this.listBoxRef).kendoListBox({
            draggable: false,
            template: this.props.field.template,
            connectWith: this.idContent,
            dataTextField: this.props.field.dataTextField,
            dataValueField: this.props.field.dataValueField,
            dropSources: [this.idContent],
            toolbar: {
                tools: ["transferTo", "transferFrom"]

            },
            remove: (e) => {
                this.moveDirectionListBox = MoveDirection.Right;
                let dataLength = this.state.RightValues.length;
                if ((dataLength >= this.props.field.maxSelectedItems && this.props.field.maxSelectedItems > 0) || (this.disabled)) {
                    e.preventDefault();
                }
                else {
                    this.updateLeft();
                }
            },
            add: (e) => {
                this.moveDirectionListBox = MoveDirection.Left;
                if (this.disabled) {
                    e.preventDefault();
                }
                else {
                    this.updateLeft();
                }
            }
        }).data("kendoListBox");
        //die rechte Liste
        this.listBoxContent = $(this.listBoxContentRef).kendoListBox({
            draggable: false,
            template: this.props.field.template,
            connectWith: this.id,
            dataTextField: this.props.field.dataTextField,
            dataValueField: this.props.field.dataValueField,
            dropSources: [this.id],
            toolbar: {
                tools: ["moveUp", "moveDown"]
            },
            remove: (e) => {
                if (this.disabled) {
                    e.preventDefault();
                }
                else {
                    this.moveDirectionListBoxContent = MoveDirection.Left;
                    this.updateRight(e.dataItems[0]);
                }
            },
            add: (e) => {
                let dataLength = this.state.RightValues.length;
                if ((dataLength >= this.props.field.maxSelectedItems && this.props.field.maxSelectedItems > 0) || (this.disabled)) {
                    e.preventDefault()
                }
                else {
                    this.moveDirectionListBoxContent = MoveDirection.Right;
                    this.updateRight(e.dataItems[0]);
                }
            },
            dragend: (e) => {
                let dataLength = this.state.RightValues.length;
                if (dataLength < this.props.field.maxSelectedItems || this.props.field.maxSelectedItems <= 0) {
                    this.updateRight(e.dataItems[0]);
                }
            },
            reorder: (e) => {
                this.moveDirectionListBoxContent = MoveDirection.Reoder;
                this.moveDirectionListBox = MoveDirection.Reoder;
                if (!this.disabled) {
                    e.preventDefault();
                    let dataSource = e.sender.dataSource;
                    let dataItem = e.dataItems[0]
                    let index = dataSource.indexOf(dataItem) + e.offset;
                    dataSource.remove(dataItem);
                    dataSource.insert(index, dataItem);

                    this.props.onChange(this.props.field, this.state.RightValues, dataItem);
                    let itemToSelect = e.items[0];
                    for (let item of this.listBoxContent.items()) {
                        if ((itemToSelect.id === item.id) || (itemToSelect.textContent === item.textContent)) {
                            this.listBoxContent.select(item);
                            break;
                        }
                    }
                    this.updateRight(e.dataItems[0]);
                }
                else {
                    e.preventDefault();
                }
            }
        }).data("kendoListBox");
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.listBox.wrapper.attr("data-readonly", this.disabled.toString());
            this.listBoxContent.wrapper.attr("data-readonly", this.disabled.toString());
        }
        const currentValues = this.props.value.map(item => item.Value).sort().join('_');
        const lastValues = prevProps.value.map(item => item.Value).sort().join('_');
        if (currentValues !== lastValues) {
            const leftValues = this.getLeftValues(this.state.AllValues, this.props.value);
            this.setState({ RightValues: this.props.value, LeftValues: leftValues }, this.setDataSources)
        }
    }

    private loadData = async () => {
        let allValues = [];
        if (Helper.hasValue(this.props.field.dataSourceUrl)) {
            allValues = await HTTPService.get(this.props.field.dataSourceUrl);
        }
        else if (Helper.hasValue(this.props.dataSource)) {
            allValues = this.props.dataSource;
        }

        let rightValues = Helper.hasValue(this.props.value) ? this.props.value : [];
        let leftValues = this.getLeftValues(allValues, rightValues);
        this.setState({ AllValues: allValues, LeftValues: leftValues, RightValues: rightValues }, () => {
            this.setDataSources();
            this.props.onDataLoaded(this.props.field, allValues);
        });
    }

    private getLeftValues = (allValues, rightValues): { leftValues } => {
        let leftValues = allValues.slice();
        if (Helper.hasValue(rightValues) && rightValues.length > 0) {
            for (let rightValue of rightValues) {
                leftValues = leftValues.filter(x => x[this.props.field.dataValueField] != rightValue[this.props.field.dataValueField]);
            }
        }
        return leftValues;
    }

    private setDataSources = () => {
        this.listBox.setDataSource(new kendo.data.DataSource({
            data: this.state.LeftValues,
        }));

        this.listBoxContent.setDataSource(new kendo.data.DataSource({
            data: this.state.RightValues,
        }));
    }

    private updateLeft = () => {
        this.listBox.wrapper.attr("data-readonly", this.disabled.toString());
        this.listBoxContent.wrapper.attr("data-readonly", this.disabled.toString());
        let left = this.listBox.dataSource.data();
        this.setState({ LeftValues: left });
    }

    private updateRight = (dataItem) => {
        this.listBox.wrapper.attr("data-readonly", this.disabled.toString());
        this.listBoxContent.wrapper.attr("data-readonly", this.disabled.toString());
        let right = this.listBoxContent.dataSource.data();
        this.setState({ RightValues: right }, () => {
            this.props.onChange(this.props.field, this.state.RightValues, dataItem);
        });
    }

    render() {
        let style = $.extend({
            width: "100%", height: this.props.field.height
        }, this.props.style);
        return (
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={style}>
                    <label> {this.props.field.labelTextLeft}</label>
                    <select id={this.id} ref={(r) => this.listBoxRef = r} style={style} />
                </div>
                <div style={style}>
                    <label> {this.props.field.labelTextRight}</label>
                    <select id={this.idContent} ref={(r) => this.listBoxContentRef = r} name={this.props.field.model} style={style} required={this.props.required} data-label={this.props.field.name} />
                </div>
            </div>
        );
    }

}

export interface ListBoxSelectProps extends BaseDataSourceComponentProps {
    field: ListBoxSelectField;
    style?: any;
}

export interface ListBoxSelectField extends BaseDataSourceField {
    dropSource?: any;
    maxSelectedItems?: number;
    template?: string;
    height: string;
    labelTextLeft?: string;
    labelTextRight?: string;
}